import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Footer from "components/home_page/Footer";
import { Link } from "react-router-dom";
import { closeModal } from "redux/actions/action-creator";
import NavLayout from "components/NavNameOfComponent/NavLayout";
import useClickOutside from "components/Custom_Hooks/useClickOutsSide";
import { useDropdownFilter } from "components/Custom_Hooks/useDropdownFilter";
import { setLastUsedVoucherData } from "utils/localStorage";
const VoucherTypeNameSelect = (props) => {
  const [state, setState] = useState({
    voucher_name: "",
    voucher_name_id: props.data?.voucher_type_id || "",
  });


  const dispatch = useDispatch();


  const filter_voucher = useSelector((state) => state.common.filter_voucher);

  const [selectedItem, setSelectedItem] = useState(0);
  const [show_name_dropdown, setshow_name_dropdown] = useState(true);

  const voucher_name_input_ref = useRef(null);
  const listContainerRef = useRef(null);

  const { voucher_name } = state;


  const handlechange = (e) => {
    const { name, value } = e.target;
    if (name === "voucher_name") {
      setState({ ...state, [name]: value });
    }
  };

  const handleFocus = (e) => {
    const { name } = e.target;
    if (name === "voucher_name") {
      setshow_name_dropdown(true);
    }
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    if (name === "voucher_name") {
      setSelectedItem(0);
      setshow_name_dropdown(false);
    }
  };

  const { filteredData } = useDropdownFilter({
    dataList: filter_voucher,
    searchInput: state?.voucher_name,
    inputRef: voucher_name_input_ref,
    isDynamic: false,
  });

  const DropdownDataHandler = (selectedLink) => {
    if (selectedLink) {
      if (show_name_dropdown) {
        setState({
          ...state,
          voucher_name: selectedLink.voucher_type_name,
        });
        props.setData({
          ...props.data,
          voucher_type_name: selectedLink.voucher_type_name,
          voucher_type_id: selectedLink?.id,
          select_type_of_voucher: selectedLink?.select_type_of_voucher,
          method_of_voucher_number: selectedLink?.method_of_voucher_number,
        });
        setLastUsedVoucherData(selectedLink);
        setshow_name_dropdown(false);
        dispatch(closeModal("voucherTypeNameSelect"));
      }
    }
  }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (show_name_dropdown) {
        if (e.key === "ArrowUp") {
          e.preventDefault();
          setSelectedItem((prevState) => Math.max(prevState - 1, 0));
        } else if (e.key === "ArrowDown") {
          e.preventDefault();
          setSelectedItem((prevState) =>
            Math.min(prevState + 1, filteredData.length - 1)
          );
        } else if (e.key === "Enter" || (e.ctrlKey && (e.key === 'a' || e.key === 'A'))) {
          e.preventDefault();
          e.stopPropagation();
          const selectedLink = filteredData[selectedItem];
          if (selectedLink) {
            DropdownDataHandler(selectedLink);
          }
        }
      }
      if (e.key === "Escape") {
        e.preventDefault();
        dispatch(closeModal("voucherTypeNameSelect"));
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedItem, show_name_dropdown, filteredData]);

  const handleWheel = useCallback((e) => {
    e.preventDefault();
    if (e.deltaY < 0) {
      setSelectedItem((prevState) => Math.max(prevState - 1, 0));
    } else if (e.deltaY > 0) {
      setSelectedItem((prevState) =>
        Math.min(prevState + 1, filteredData.length - 1)
      );
    }
  }, [filteredData.length]);

  useEffect(() => {
    if (show_name_dropdown) {
      window.addEventListener("wheel", handleWheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, [show_name_dropdown, handleWheel]);

  useEffect(() => {
    if (listContainerRef.current) {
      const selectedElement = listContainerRef.current.querySelector(".selected");
      if (selectedElement) {
        const containerHeight = listContainerRef.current.offsetHeight;
        const elementTop = selectedElement.offsetTop - listContainerRef.current.offsetTop;
        const elementBottom = elementTop + selectedElement.offsetHeight;

        if (elementTop < listContainerRef.current.scrollTop) {
          listContainerRef.current.scrollTop = elementTop;
        } else if (elementBottom > listContainerRef.current.scrollTop + containerHeight) {
          listContainerRef.current.scrollTop = elementBottom - containerHeight;
        }
      }
    }
  }, [selectedItem]);

  const handleClickOutside = (event) => {
    if (voucher_name_input_ref?.current) {
      event.preventDefault();
      voucher_name_input_ref.current.focus();
    } else if (voucher_name_input_ref?.focus) {
      event.preventDefault();
      voucher_name_input_ref.focus();
    }
  };

  const handleClickInside = (event) => {
    let clickedElement = event.target;
    if (
      clickedElement?.tagName &&
      (clickedElement?.tagName.toLowerCase() === "input" ||
        clickedElement?.tagName.toLowerCase() === "textarea")
    ) {
      clickedElement.focus();
    }
  };

  useClickOutside(voucher_name_input_ref, handleClickOutside, handleClickInside);

  return (
    <div className="my-card">
      <div
        className="cross_button"
        onClick={() => {
          return dispatch(closeModal("voucherTypeNameSelect"));
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <NavLayout>
        <b className="ps-2">Change Voucher Type </b>
      </NavLayout>

      <div className="container pb-3" id="card-period">
        <div className="row">
          <div className="col">
            <b className="border-bottom">Voucher Type</b>
          </div>
        </div>
        <div className="row m-1">
          <div className="col">
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Name</label>
              <label>:</label>
              <input
                type="text"
                autoComplete="off"
                autoFocus
                name="voucher_name"
                id="voucher_name"
                ref={voucher_name_input_ref}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={handlechange}
                value={voucher_name || ""}
                className="lab-right"
              />
              <div
                className={`dropdown_number_series ${show_name_dropdown ? "show-list" : ""}`}
                style={{
                  display: show_name_dropdown ? "flex" : "none",
                  flexDirection: "column",
                  overflow: "hidden",
                  padding: 0
                }}
              >
                <div className="col background" style={{ position: "sticky", top: 0, flexShrink: 0 }}>
                  List of voucher type
                </div>
                <div id="data" ref={listContainerRef} style={{ overflowY: "auto", flex: 1 }}>
                  {filteredData?.length > 0 ? (
                    filteredData?.map((key, number) => {
                      const name = key?.voucher_type_name;
                      const index = name
                        ?.toLowerCase()
                        ?.indexOf(voucher_name?.toLowerCase());
                      return (
                        <Link
                          className={`list ${number === selectedItem ? "selected" : ""
                            }`}
                          key={number}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            setSelectedItem(number);
                            DropdownDataHandler(key);
                          }}
                        >
                          {index !== -1 ? (
                            <>
                              {name?.substring(0, index)}
                              <span style={{ color: "red" }}>
                                {name?.substring(
                                  index,
                                  index + voucher_name.length
                                )}
                              </span>
                              {name?.substring(index + voucher_name.length)}
                            </>
                          ) : (
                            name
                          )}
                        </Link>
                      );
                    })
                  ) : (
                    <p style={{ color: "red" }}>No matching items found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
};
export default VoucherTypeNameSelect;
